import React from "react";
import { CardContainer, Header, Body, Footer } from "./components";

export default (props) => {
  return (
    <CardContainer>
      <Header
        title={props.title}
        onCertificate={props.certificate}
        onDelete={props.delete}
        onView={props.view}
        onEdit={props.edit}
        onReactivate={props.reactivate}
        isActive={props.isActive}
      />
      <Body children={props.children} />
      <Footer footer={props.footer} />
    </CardContainer>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Card/index.jsx